import { Box, Heading, Text, Button, Flex } from '@chakra-ui/react';
import { useTranslation } from '../translations/useTranslation';

export default function NotListedAnything() {
  const { t } = useTranslation();
  
  return (
<Flex
  direction="column"
  alignItems="center"
  justifyContent="center"
  minH="80vh"
>
  <Box textAlign="center" py={10} px={6}>
    <Heading
      display="inline-block"
      as="h2"
      size="2xl"
      bgGradient="linear(to-r, teal.400, teal.600)"
      backgroundClip="text"
    >
      {t('nothingListed')}
    </Heading>
    <Text fontSize="18px" mt={3} mb={2}>
      {t('nothingListedYet')}
    </Text>
    <Text color={"gray.500"} mb={6}>
      {t('letGoUnused')}
    </Text>

    <a href="/">
      <Button
        colorScheme="teal"
        bgGradient="linear(to-r, teal.400, teal.500, teal.600)"
        color="white"
        variant="solid"
      >
        {t('goToHome')}
      </Button>
    </a>
  </Box>
</Flex>
  );
}